import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";

import ConsumptionData from "./ConsumptionData";
import ConsumptionPatterns from "./ConsumptionPatterns";
import CustomerDetails from "./CustomerDetails";
import RegistrationData from "./RegistrationData";
import { Button, Loading, Message } from "@components";
import { useEffect, useState } from "react";
import InternalBenefitAPI from "providers/InternalBenefitAPI";
import dayjs from "dayjs";
import { UserStorage } from "shared/tools/UserStorage";
import ROLES from "data/Roles";
import CustomerMarkups from "./CustomerMarkups";

export const Data = ({ customer, loadCustomer }) => {
  const [loading, setLoading] = useState(false);
  const [block, setBlock] = useState(false);

  const allowsBlockBenefit = [ROLES.SUPPORT, ROLES.ADMIN].includes(
    UserStorage.getLoggedUser()?.role,
  );

  const onLoad = async () => {
    setLoading(true);

    const internalBenefitAPI = new InternalBenefitAPI();
    const blockResponse = await internalBenefitAPI.getCustomerBlock(
      customer.id,
    );
    const block = blockResponse.getData(null);
    setBlock(block);

    setLoading(false);
  };

  const getBlockMessage = () => {
    if (!block) {
      return "";
    }

    const userName = block.created_by?.name;
    const deletedAt = dayjs(block.created_at).format("DD/MM/YY");

    if (!userName) {
      return `Bloqueado em ${deletedAt}`;
    }

    return `Bloqueado em ${deletedAt} por ${userName}`;
  };

  const blockCustomer = async () => {
    const confirmed = await window.confirm({
      text: `Você tem certeza que deseja bloquear o uso de benefícios do cliente?`,
      confirmText: "Sim",
      cancelText: "Cancelar",
    });

    if (!confirmed) {
      return false;
    }

    setLoading(true);

    const internalBenefitAPI = new InternalBenefitAPI();
    const response = await internalBenefitAPI.blockCustomer(customer.id);

    if (response.getErrors([]).length > 0) {
      setLoading(false);
      return alert({ text: response.getErrors([])[0], buttonText: "Ok" });
    }

    await onLoad();
  };

  const unblockCustomer = async () => {
    const confirmed = await window.confirm({
      text: `Você tem certeza que deseja desbloquear o uso de benefícios do cliente?`,
      confirmText: "Sim",
      cancelText: "Cancelar",
    });

    if (!confirmed) {
      return false;
    }

    setLoading(true);

    const internalBenefitAPI = new InternalBenefitAPI();
    const response = await internalBenefitAPI.unblockCustomer(customer.id);

    if (response.getErrors([]).length > 0) {
      setLoading(false);
      return alert({ text: response.getErrors([])[0], buttonText: "Ok" });
    }

    await onLoad();
  };

  const blockMessage = getBlockMessage();

  useEffect(() => {
    if (customer) {
      onLoad();
    }
  }, [customer]);

  return (
    <div className={styles.customerData}>
      {blockMessage && (
        <Message
          type="danger"
          title="Uso de benefício bloqueado!"
          text={blockMessage}
          className={"mb-20"}
        />
      )}

      {loading ? (
        <div className={styles.loading}>
          <Loading />
        </div>
      ) : (
        <>
          <CustomerDetails customer={customer} />
          <RegistrationData customer={customer} />
          <ConsumptionData customer={customer} />
          <CustomerMarkups customer={customer} loadCustomer={loadCustomer} />
          <ConsumptionPatterns customer={customer} />

          {!block && allowsBlockBenefit && (
            <div className="mt-35 d-flex justify-center w-100">
              <Button design="underline" onClick={blockCustomer}>
                Bloquear uso de benefício
              </Button>
            </div>
          )}

          {block && (
            <div className="mt-35 d-flex justify-center w-100">
              <Button design="underline" onClick={unblockCustomer}>
                Desbloquear uso de benefício
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
